module.exports = __webpack_public_path__ + "static/img/app_big.8434178.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app_big.png
// module id = n2WY
// module chunks = 47